<template>
    <div class="field">
        <label class="label">{{ translate("event_ranking.rule.awardPointsForWin.label1") }}</label>
        <div class="control">
            <input class="input" type="number" min="1" v-model="pointsForWinning" />
        </div>
    </div>
    <div class="mb-2">
        <Checkbox2 v-model="promoteSubmissionEnabled">
            {{ translate("event_ranking.rule.promoteSubmission.label1") }}
        </Checkbox2>
    </div>
    <div class="field">
        <div class="control">
            <input
                class="input"
                type="number"
                min="1"
                max="100"
                v-model="multiplierForSubmissionWin"
                :disabled="!promoteSubmissionEnabled"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, onMounted, ref, watch } from "vue";
    import { AwardPointsForWinArguments, RuleDefinition } from "./types";
    import { useDefineRuleStore } from "./defineRuleStore";
    import { translate } from "../../Common/translations";
    import Checkbox2 from "../../Common/Checkbox2.vue";
    import { isIntegerOrFloatGreaterThan0 } from "../../Common/numbers";

    const defineRuleStore = useDefineRuleStore();

    const pointsForWinning = ref(10);
    const promoteSubmissionEnabled = ref(false);
    const multiplierForSubmissionWin = ref<number | null>(2);

    const isValid = computed(() => {
        if (!pointsForWinning.value || pointsForWinning.value <= 0) {
            return false;
        }
        if (
            promoteSubmissionEnabled.value &&
            (!multiplierForSubmissionWin.value || !isIntegerOrFloatGreaterThan0(multiplierForSubmissionWin.value))
        ) {
            return false;
        }
        return true;
    });

    watch(pointsForWinning, () => {
        defineRuleStore.selectedRuleValid = isValid.value;
    });
    watch(promoteSubmissionEnabled, () => {
        defineRuleStore.selectedRuleValid = isValid.value;
    });
    watch(multiplierForSubmissionWin, () => {
        defineRuleStore.selectedRuleValid = isValid.value;
    });

    function getRuleDefinition(): RuleDefinition {
        return {
            rule: "awardPointsForWin",
            selectedCategories: [],
            arguments: {
                pointsForWinning: pointsForWinning.value,
                multiplierForSubmissionWin: promoteSubmissionEnabled.value ? Number(multiplierForSubmissionWin.value) : null,
            } satisfies AwardPointsForWinArguments,
            argumentsAsString: `${pointsForWinning.value}`,
            valid: isValid.value,
        };
    }

    defineExpose({ getRuleDefinition });

    onMounted(() => {
        defineRuleStore.selectedRuleValid = isValid.value;
    });
</script>

<style scoped></style>
